var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33801V3.33301H33.33C34.25 3.33301 35 4.09134 35 4.98634V35.013C34.9996 35.4517 34.825 35.8722 34.5147 36.1822C34.2044 36.4922 33.7837 36.6663 33.345 36.6663H6.65504C6.43617 36.6648 6.21974 36.6202 6.01812 36.535C5.81649 36.4499 5.63362 36.3258 5.47993 36.1699C5.32625 36.0141 5.20477 35.8295 5.12243 35.6267C5.04009 35.4239 4.9985 35.2069 5.00004 34.988V13.333L15 3.33801ZM9.71671 13.333H15V8.04967L9.71671 13.333ZM18.3334 6.66634V14.9997C18.3334 15.4417 18.1578 15.8656 17.8452 16.1782C17.5327 16.4907 17.1087 16.6663 16.6667 16.6663H8.33337V33.333H31.6667V6.66634H18.3334Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/IconFile.769927ad.svg";
export { ForwardRef as ReactComponent };